/**
 * 現在のお届け先住所を担う
 */
import * as AddressFormatter from "@shopify/address/build/ts/index";
import { useState, useEffect } from 'react';
import { SubscriptionState } from "../App/useSubscription";

export const useShippingAddress = (
  subscription: SubscriptionState,
) => {

  const [shippingAddress, setShippingAddress] = useState<ShippingAddress>();

  const addressFormatter = new AddressFormatter.default("ja");

  useEffect(() => {
    if (!subscription) return;

    (async() => {
      const countryData = await addressFormatter.getCountry(subscription.deliveryCountryCode);

      setShippingAddress({
       ...shippingAddress,
        address1: subscription.deliveryAddress1,
        address2: subscription.deliveryAddress2,
        city: subscription.deliveryCity,
        company: subscription.deliveryCompany,
        countryCode: subscription.deliveryCountryCode,
        firstName: subscription.deliveryFirstName,
        lastName: subscription.deliveryLastName,
        phone: subscription.deliveryPhone,
        provinceCode: subscription.deliveryProvinceCode,
        zip: subscription.deliveryZip,
        countryData 
      });
    })();
  }, [
    subscription?.deliveryAddress1,
    subscription?.deliveryAddress2,
    subscription?.deliveryCity,
    subscription?.deliveryCompany,
    subscription?.deliveryCountryCode,
    subscription?.deliveryFirstName,
    subscription?.deliveryLastName,
    subscription?.deliveryPhone,
    subscription?.deliveryProvinceCode,
    subscription?.deliveryZip,
  ]);

  return shippingAddress;
};

// types

export type ShippingAddress = {
  address1?: string;
  address2?: string;
  city?: string;
  company?: string;
  countryCode?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  provinceCode?: string;
  zip?: string;
  countryData?: AddressFormatter.Country;
};
